(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    function hideEmptyAccordionRows() {
    document.querySelectorAll('details[data-testid="accordion-details"]').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      var content = details.querySelector(':scope > .details-content');
      var summaryEmpty = !summary || summary.textContent.trim() === '';
      var contentEmpty = !content || content.textContent.trim() === '';
      var wrapper = details.closest('accordion-custom') || details;

      wrapper.classList.toggle('accordion-row-3dids-hidden-empty', summaryEmpty || contentEmpty);
    });
  }

  hideEmptyAccordionRows();

  document.addEventListener('shopify:section:load', hideEmptyAccordionRows);
  document.addEventListener('shopify:block:select', hideEmptyAccordionRows);
  document.addEventListener('shopify:block:deselect', hideEmptyAccordionRows);

  new MutationObserver(hideEmptyAccordionRows).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-announcement-marquee]').forEach((viewport) => {
    const text = viewport.querySelector('[data-announcement-text]');

    if (!text) return;

    const updateScrolling = () => {
      const isScrolling = text.scrollWidth > viewport.clientWidth + 1;
      viewport.classList.toggle('is-scrolling', isScrolling);
    };

    updateScrolling();
    window.addEventListener('resize', updateScrolling);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('.product-details');
    if (!root) return;

    var findLabel = function (text) {
      var blocks = root.querySelectorAll('.text-block');
      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].textContent.trim() === text) return blocks[i];
      }
      return null;
    };

    var anchuraLabel = findLabel('Anchura');
    var fondoLabel = findLabel('Fondo');
    if (!anchuraLabel || !fondoLabel) return;

    var group = anchuraLabel.closest('.group-block');
    while (group && !group.contains(fondoLabel)) {
      var parent = group.parentElement;
      group = parent ? parent.closest('.group-block') : null;
    }
    if (!group) return;

    var missing = ['Anchura', 'Altura', 'Fondo'].some(function (label) {
      var labelEl = findLabel(label);
      if (!labelEl) return true;
      var card = labelEl.closest('.group-block');
      return !card || card.textContent.trim() === label;
    });

    if (missing) {
      group.style.display = 'none';
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    function hideEmptyAccordions() {
    document.querySelectorAll('.accordion').forEach(function (accordion) {
      var rows = accordion.querySelectorAll(':scope > accordion-custom');
      if (rows.length === 0) return;

      var allRowsHidden = Array.prototype.every.call(rows, function (row) {
        return row.classList.contains('accordion-row-3dids-hidden-empty');
      });

      accordion.classList.toggle('accordion-3dids-hidden-empty', allRowsHidden);
    });
  }

  hideEmptyAccordions();

  document.addEventListener('shopify:section:load', hideEmptyAccordions);
  document.addEventListener('shopify:block:select', hideEmptyAccordions);
  document.addEventListener('shopify:block:deselect', hideEmptyAccordions);

  new MutationObserver(hideEmptyAccordions).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["color-pills-3dids"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-color-pills]').forEach((wrapper) => {
    const track = wrapper.querySelector('[data-color-pills-track]');
    const next = wrapper.querySelector('[data-color-pills-next]');

    if (!track || !next) return;

    const updateOverflow = () => {
      const hasOverflow = track.scrollWidth > track.clientWidth + 1;
      next.hidden = !hasOverflow;
      wrapper.classList.toggle('has-overflow', hasOverflow);
    };

    next.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => {
      const hasOverflow = track.scrollWidth > track.clientWidth + 1;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      next.hidden = !hasOverflow || atEnd;
      wrapper.classList.toggle('has-overflow', hasOverflow && !atEnd);
    });

    updateOverflow();
    window.addEventListener('resize', updateOverflow);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-carousel-3dids"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-image-carousel]').forEach((wrapper) => {
    const track = wrapper.querySelector('[data-image-carousel-track]');
    const prev = wrapper.querySelector('[data-image-carousel-prev]');
    const next = wrapper.querySelector('[data-image-carousel-next]');

    if (!track) return;

    const updateArrows = () => {
      const hasOverflow = track.scrollWidth > track.clientWidth + 1;
      if (prev) prev.hidden = !hasOverflow || track.scrollLeft <= 0;
      if (next) {
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        next.hidden = !hasOverflow || atEnd;
      }
    };

    if (prev) {
      prev.addEventListener('click', () => {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows);
    updateArrows();
    window.addEventListener('resize', updateArrows);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-type-tabs-3dids"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-type-tabs]').forEach((tabs) => {
    const wrapper = tabs.closest('.collection-wrapper') || tabs.parentElement;

    const applyFilter = (target) => {
      wrapper.querySelectorAll('.product-grid__item').forEach((item) => {
        const matches = target === 'all' || item.dataset.productType?.toLowerCase().trim() === target;
        item.hidden = !matches;
      });
    };

    tabs.addEventListener('click', (event) => {
      const button = event.target.closest('[data-product-type-tab]');
      if (!button) return;

      const target = button.dataset.productTypeTab;

      tabs.querySelectorAll('[data-product-type-tab]').forEach((tab) => {
        tab.classList.toggle('is-active', tab === button);
      });

      applyFilter(target);
    });

    const activeTab = tabs.querySelector('.is-active');
    const initialTarget = activeTab ? activeTab.dataset.productTypeTab : 'all';

    const grid = wrapper.querySelector('.product-grid, ul, ol') || wrapper;
    const observer = new MutationObserver(() => {
      const current = tabs.querySelector('.is-active')?.dataset.productTypeTab || 'all';
      applyFilter(current);
    });
    observer.observe(grid, { childList: true });

    applyFilter(initialTarget);
  });
  } catch(e) { console.error(e); }
})();

})();
